<div class="whatsapp-button rounded-full bg-mj-verde-1 shadow-md flex justify-center items-center w-[50px] md:w-[60px] md:h-[60px] lg:w-[70px] h-[50px] lg:h-[70px] rounded hover:scale-105 transform transition-transform duration-300 ease-in-out">
  <a href="https://api.whatsapp.com/send?phone=573107154095" target="_blank" class="w-[35px] lg:w-[72px] lg:h-[65px] no-underline block">
    <img src="assets/images/icons/WEB_whatsapp-negative.svg" alt="whatsapp"  class=" fill-[white] whatsapp-button__icon">
  </a>
  
</div>
<!-- <div class="whatsapp-button rounded-full bg-white shadow-md flex justify-center items-center w-[50px] md:w-[60px] md:h-[60px] lg:w-[70px] h-[50px] lg:h-[70px] hover:scale-105 transform transition-transform duration-300 ease-in-out mt-2" (click)="navegateCv()">

    <img class="w-[35px] lg:w-[72px] lg:h-[65px] no-underline block" src="assets/images/eslabon.png" alt="whatsapp"  class=" fill-[white] whatsapp-button__icon">

  
</div> -->


<!-- bg-blue-500 text-white font-bold py-2 px-4  -->